import { render, staticRenderFns } from "./carList.vue?vue&type=template&id=134f2f51&scoped=true"
import script from "./carList.vue?vue&type=script&lang=js"
export * from "./carList.vue?vue&type=script&lang=js"
import style0 from "./carList.vue?vue&type=style&index=0&id=134f2f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f2f51",
  null
  
)

export default component.exports